import { Link } from "office-ui-fabric-react"

const ApiInfoTooltip = () => {
    return <div>
        Please refer to these <Link href="https://help.ppm.express/public-api" target="_blank">articles</Link> for more details.
    </div>
}

export default ApiInfoTooltip;